import React from 'react';
import { I18n } from 'react-redux-i18n';

import * as S from './Alternative.styles';

export const Alternative = () => {
  return <S.Alternative>{I18n.t('login.alternative')}</S.Alternative>;
};
